export const USER_LOGOUT = 'USER_LOGOUT'



// WEBPACK FOOTER //
// ./src/pages/logout/constants.ts